module.exports = __webpack_public_path__ + "img/Guinea-Bissau.5cae8d9a.svg";